import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const SoldOutIcon: FC<IconProps> = ({ width = 24, height = 24, ...rest }) => (
  <Icon type="SoldOut" width={width} height={height} alt="SoldOut" {...rest} />
)
